module.exports = __webpack_public_path__ + "img/Wp_2094.dd382d44.png";